import {gql} from '@apollo/client';

export const fieldQueries = {
    GET_BOARD_FIELDS_BY_ID: gql`
        query boardFieldsById($boardId: UUID!) {
            boardFieldsById(boardId: $boardId) {
                id
                defaultValue
                value
                active
                validationMessage
                uniqueId
                fieldCategory
                fieldType
                dataType
                regularExpression
                title
                placeHolder
                helperText
                isRequired
                shouldUseAsTheFieldToCreateItem
                formula
                format
                isReadOnly
            }
        }
    `,
};
